import CharacterData from "./CharacterData";
import * as React from 'react';
import Grid from '@mui/material/Grid';


export default function CharacterCard(props) {


    function createCards() {
        let items = []

        function characterImage(value) {

            let photo;
            try {
                photo = require("../content/" + value.photo.location)
            } catch (error) {
                console.warn("Looks like the photo was missing for: " + value.name)
                return null
            }

            if (value.disable != null) {
                return null;
            }

            let text = <>
                <p>{value.name}</p>
                <p>{value.nick}</p>
                <p>{value.pronouns}</p>
            </>
            if (value.photo.fliptext != null) {
                text = <>
                    <p>{value.pronouns}</p>
                    <p>{value.nick}</p>
                    <p>{value.name}</p>
                </>
            }

            return <>
                <img src={photo} className="char-photo"
                     alt={value.name}/>
                <div className={"grid-text grid-" + value.photo.align}>
                    {text}
                </div>
                <div className={"grid-roles-text grid-roles-" + value.photo.align.split("-")[0]}>
                    <p>{value.roles}</p>
                </div>
            </>;
        }

        function characterText(value) {
            return <>
                <div className={"grid-about"}>
                    <b>Hunting Since</b>
                    <p>{value.since}</p>

                    <b>About</b>
                    <p>{value.about}</p>
                </div>
            </>;
        }

        function doClick(value) {
            props.updateCards(value.name);
        }

        let character_data = [...CharacterData]

        character_data = character_data.sort(
            function compareFn(a, b) {
                return a.name.localeCompare(b.name)
            }
        )

        for (let key in character_data) {
            let value = character_data[key];
            let image = characterImage(value)
            if (image === null) continue

            items.push(
                <Grid item xs={3}>
                    <div className="grid-card" onClick={() => doClick(value)}>
                        {props.characterCards.includes(value.name) ? characterText(value) : image}
                    </div>
                </Grid>
            )
        }

        return items;
    }

    return (
        <>
            {createCards()}
        </>
    )
}